import { FormGroup } from '@angular/forms';
import { FormInput } from './form-input.model';

export interface FormDialog { 
  title: string;
  inputs: FormInput[];
  formGroup: FormGroup;
}